import React from 'react'

function InfoPlacesSection({
    icon,
    title='info',
    children
}) {
    return (
        <div className='infoPlacessectionCont mt-3'>
            <h4 className='mb-3'><span className='mr-3'>{icon}</span>{title}</h4>
            {children}
        </div>
    )
}
export default InfoPlacesSection
